import { render } from "./bank-audit-trail-modal.html?vue&type=template&id=7b485364&scoped=true&ts=true&external"
import script from "./bank-audit-trail-modal.ts?vue&type=script&lang=ts&external"
export * from "./bank-audit-trail-modal.ts?vue&type=script&lang=ts&external"

import "./bank-audit-trail-modal.scss?vue&type=style&index=0&id=7b485364&scoped=true&lang=sccs&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b485364"]])

export default __exports__